<template>
  <div class="lucky-box">
    <div class="banner">
      <img :src="activity.main_pic" mode="" />
    </div>
    <!-- 选择福袋商品 -->
    <div class="choose-box">
      <div class="choose-swiper"
        :style="{ backgroundImage: 'url('+activity.main_img+')',backgroundSize: 'cover' }">
      </div>
      <!-- 图片集合 -->
      <div class="imgList">
        <img :src="item" mode="widthFix" v-for="item,index in activity.images" :key="index"/>
      </div>
    </div>
  </div>
</template>

<script>
import apiGo from "./apiGo";
import service from './service'
import 'swiper/dist/css/swiper.css'
import {swiper, swiperSlide} from 'vue-awesome-swiper'
let _this = null
export default {
  data() {
    return {
      shotId: 0,
      activeIndex: 1,
      pageSource: '', // 渠道-公
      modulesShow: { // 显示问题-公
        hasSwiper: false,
        hasName: false,
        hasChannel: false,
        hasNumber: false,
        hasDetail: false,
      },
      vipNormalDetailConfig: {}, // 会员普通商品-私
      orderId: '',
      openId: '',
      activity: {}
    };
  },
  components: {
    swiper,
    swiperSlide
  },
  watch: {},
  created() {
    _this = this
  },
  mounted() {
    console.error(this.$route)
    this.shotId = this.$route.query.shotId
    this.orderId = this.$route.query.orderId
    this.openId = this.$route.query.openId
    this.getVipNormalDetail()
  },
  methods: {
    // 商品快照详情接口-私
    async getVipNormalDetail () {
      let params = {
        order_no: this.orderId, // 自提
        openid: this.openId,
      }
      params = service.creatSign(params)
      const {data:{order_detail}} = await apiGo.getStoreVipTrans(params)
      console.log('order_detailorder_detailorder_detailorder_detail')
      console.log('order_detailorder_detailorder_detailorder_detail')
      console.log(order_detail.goods_list)
      const info = order_detail.goods_list.filter(e => e.goods_spu_id == this.shotId)
      console.log(info)
      this.activity = info.length ? info[0].snapshot : {}
      console.log(this.activity)
      // this.goodsDetail = service.vipNormalDetailService(order_detail, _this.shotId, this.vipNormalDetailConfig)
    },
  },
};
</script>

<style>
.lucky-box {
  width: 100%;
  height: 100vh;
}
.banner {
  width: 100%;
  height: 600px;
  position: relative;
}
.banner img {
  width: 100%;
  height: 600px;
}
.choose-box {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.imgList {
  width: 100%;
}
.imgList img {
  width: 100%;
  display: block;
}
.imgList img:first-child {
  margin-top: -86rpx;
}

.choose-swiper {
  width: 260px;
  height: 360px;
  background: url('') no-repeat;
  background-size: cover;
  position: absolute;
}
.item {
  width: 240px;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: white;
  font-size: 20px;
}
.item img {
  width: 240px;
  height: 240px;
}
</style>
